var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlightActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5V15.5M1.5 6.5H8M8.5 10.5H15.5M3 16H14C15.1046 16 16 15.1046 16 14V3C16 1.89543 15.1046 1 14 1H3C1.89543 1 1 1.89543 1 3V14C1 15.1046 1.89543 16 3 16Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.5,
    y1: 1,
    x2: 16,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#4991C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8E559D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightActive);
export default __webpack_public_path__ + "static/media/highlight--active.738f5bc74c7fbb2bdbca98ecad93f989.svg";
export { ForwardRef as ReactComponent };